import { Box } from '@mui/material';
import React, { ReactNode } from 'react';

import { AppHeader } from './AppHeader';
import * as SC from './styles';

export const MainLayout = ({ children }: { children: ReactNode }) => (
  <SC.Layout $bgMainOffset={0}>
    <AppHeader/>
    <Box
      component="main"
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {children}
    </Box>
  </SC.Layout>
);
